import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyFormaterPipe } from 'src/app/pipes/currencyReduce.pipe';
import { OrderService } from 'src/app/services/order.service';

export interface Payment {
  name: string;
  code: string;
}

@Component({
  selector: 'app-payment-type',
  templateUrl: './payment-type.component.html',
  styleUrls: ['./payment-type.component.scss']
})
export class PaymentTypeComponent implements OnInit {
  public paymentList: Payment[] = [];
  public payment: Payment;
  @Output() changePaymentMethod = new EventEmitter<any>();
  @Input() readonly: boolean = false;
  @Input() prepaidMode: boolean = false;

  constructor(private translate: TranslateService, private orderService: OrderService, private currencyPipe: CurrencyPipe, private currencyReduce: CurrencyFormaterPipe) {

    this.orderService.getPrepaidAmount().subscribe(data => {
      if(data.success) {
        let prepaid_amount = this.currencyReduce.transform(data.data.prepaid_amount, true);
        let prepaid_amount_ = this.currencyPipe.transform(prepaid_amount, "PLN");

        this.paymentList = [
          { name: this.translate.instant("payment_payu"), code: "payu" },
          { name: this.translate.instant("paymanet_standard"), code: "transfer" },
          { name: this.translate.instant("payment_paypal"), code: "paypal" },
          { name: this.translate.instant("payment_prepaid") + " (" + prepaid_amount_ + ")", code: "prepaid" }
        ];
        if(this.prepaidMode) {
          this.paymentList = [
            { name: this.translate.instant("payment_payu"), code: "payu" },
            { name: this.translate.instant("payment_paypal"), code: "paypal" },
          ];
        }
      }
    });



   }

   onChangePayment(payment) {
    this.changePaymentMethod.next(payment);
   }

  ngOnInit(): void {
  }

}
